import React, { useEffect, useState } from 'react';
import { useSearch } from '@okapi/router-react';
import { Modal, Typography } from 'common/components';
import { ChevronRightIcon } from '@fronton/icons-react';
import { createElementKey, removeSpecialCharacters } from 'utils';
import { KITCHEN_ELEMENT_BLOCK } from 'landings/kitchen/kitchen-constants';
import { analyticsUtils } from 'utils/analytics-utils';
import {
  newKitchenHeaderCardGrid,
  newKitchenHeaderCardItem,
  newKitchenHeaderCardItemContent,
  newKitchenHeaderCardItemIcon,
  newKitchenHeaderCardItemIconWrapper,
  newKitchenHeaderCardItemImage,
  newKitchenHeaderCardItemText,
  newKitchenHeaderCardModal,
} from './new-kitchen-header-card-styles';
import { HEADER_CARD_LIST, HeaderCardStructure } from './new-kitchen-header-card-constants';

type HeaderCardProps = {
  signUpHref: string;
}

export const NewKitchenHeaderCard: React.FC<HeaderCardProps> = ({ signUpHref }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [searchParams] = useSearch();
  const [activeItem, setActiveItem] = useState<HeaderCardStructure | null>(null);
  const cardList = HEADER_CARD_LIST;

  useEffect(() => {
    cardList?.forEach(item => {
      if (item.name && searchParams.benefits === item.name) {
        setActiveItem(item);
        setIsModalOpen(true);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleItemClick = (item: HeaderCardStructure) => () => {
    setActiveItem(item);
    setIsModalOpen(true);

    analyticsUtils.clickButtonEvent(
      KITCHEN_ELEMENT_BLOCK,
      removeSpecialCharacters(item.text),
      'Кухни под ваши размеры'
    );

    analyticsUtils.sendEvent('GA:show', {
      elementType: 'block',
      elementBlock: KITCHEN_ELEMENT_BLOCK,
      elementText: `${removeSpecialCharacters(item.text)} / modal`,
      elementName: 'Модальное окно',
    });
  };

  return (
    <>
      <ul className={newKitchenHeaderCardGrid}>
        {cardList.map((item, index) => (
          <li key={createElementKey('header-item', index)}>
            <button className={newKitchenHeaderCardItem} onClick={handleItemClick(item)}>
              <img
                className={newKitchenHeaderCardItemImage}
                src={item.icon.src}
                alt={item.icon.alt}
                width="36"
                height="36"
              />
              <div className={newKitchenHeaderCardItemContent}>
                <Typography
                  className={newKitchenHeaderCardItemText}
                  variant="m"
                  size="body_long"
                >
                  {item.text}
                </Typography>
                <div className={newKitchenHeaderCardItemIconWrapper}>
                  <ChevronRightIcon
                    className={newKitchenHeaderCardItemIcon}
                    type="outline"
                    size="l"
                    color="text-minor"
                  />
                </div>
              </div>
            </button>
          </li>
        ))}
      </ul>

      {
        activeItem && (
          <Modal
            className={newKitchenHeaderCardModal}
            onClose={() => setIsModalOpen(false)}
            show={isModalOpen}
            size="m"
            variant="curtain">
            <activeItem.modal onCloseModal={() => setIsModalOpen(false)} signUpHref={signUpHref} />
          </Modal>
        )
      }
    </>
  )
}
